import React, { Component, Fragment } from 'react';
import { Form, Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';

import moment from 'moment';
import Auth from '../../Auth/Auth';
import IsLoadingBar from '../isLoading';

import './KPI.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const auth = new Auth();

function imageConverter(cell, row) { 
    return (
        cell !== null ? 
        <a href={cell} download="filename">Download Image</a>
        : ""
    );
}

function EmailFormatter(cell, row) { 
    let body = `Hi ${row.username}, \n \nThank you for the following feedback. \n    ${row.feedback}  \n \n \n Sent using Fetch Feedback`;
    return (
        <a href={`mailto:${cell}?subject=Fetch Feedback&body=${encodeURIComponent(body)}`}>{cell}</a>
    );
}


function DateFormatter(cell, row) {  
    return (
        <span>{moment(cell).format('MM-D-YYYY, h:mm:ss a')}</span>
    );
}

function checkmarkConverter(cell, row, rowIndex, formatExtraData) { 
    return (
        <Form.Check
            custom
            label=""
            type={'checkbox'}
            onChange={(e) => formatExtraData.app.FeedbackActioned(e)}
            checked={cell}
            value={row.feedbackId}
            id={`${row.feedbackId}`}
        />
    );
}

export default class Feedback extends Component {
    constructor(props){
        super(props);

        this.state = {
            Feedback: this.props.Feedback,
            isLoading: true
        };
    }

    async componentDidMount(){
        let accessToken = await auth.getToken()
        fetch('/api/getUserFeedback', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            this.setState({
                Feedback: data[0],
                isLoading: false
            });
        }).catch((error) => {
            window.apiError(error);
        });
    }


    async FeedbackActioned(e){
        var checkId = e.target.id;
        var checked = e.target.checked;
        let action = {
            action : e.target.checked,
            feedbackId: e.target.value
        };

        let accessToken = await auth.getToken();
        fetch(`/api/actionFeedback`,{
            method : "POST",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
            },
            body: JSON.stringify(action)
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
            })
            .then(success => {
                if(checked){
                    document.getElementById(checkId).checked = true;
                } else {
                    document.getElementById(checkId).checked = false;
                }                
            }).catch((err) => {
                window.apiError(err);
            });
    }

    render () { 
        let self = this;

        const columns = [{
            dataField: 'feedbackId',
            text: 'feedbackId',
            sort: true,
            hidden: true
          }, {
            dataField: 'username',
            text: 'username',
            sort: true
          }, {
            dataField: 'userEmail',
            text: 'userEmail',
            sort: true,
            formatter: EmailFormatter
          }, {
            dataField: 'feedbackUTCTimestamp',
            text: 'Date/Time',
            sort: true,
            formatter: DateFormatter
          }, {
            dataField: 'feedbackOption',
            text: 'feedbackOption',
            sort: true,
          }, {
            dataField: 'feedback',
            text: 'feedback',
            sort: true,
          }, {
            dataField: 'feedbackImage',
            text: 'feedbackImage',
            sort: true,
            formatter: imageConverter
          }, {
            dataField: 'lastSearch',
            text: 'lastSearch',
            sort: true
          }, {
            dataField: 'isActioned',
            text: 'isActioned',
            sort: true,
            width: "100px",
            formatter: checkmarkConverter,
            formatExtraData: {
                app : self
            }
          }];
        
          const defaultSorted = [{
            dataField: 'feedbackUTCTimestamp',
            order: 'desc'
          }];

          
        if(this.state.isLoading){
            return (
                <IsLoadingBar />
            );
        }
          
        return(
            <div className="feedback-manager" style={this.state.expanded ? {width: "90vw"} : {}}>
                <Button variant="link" className="p-0" onClick={() => this.setState({expanded : !this.state.expanded})}>Expand/Shrink</Button>
                <BootstrapTable
                    bootstrap4
                    keyField="feedbackId"
                    data={ this.state.Feedback }
                    columns={ columns }
                    defaultSorted={ defaultSorted } 
                />
            </div>
        );
    }
}